import { addDoc, deleteDoc, doc, getDoc, getDocs, orderBy, query, updateDoc, where } from 'firebase/firestore';
import {
    DistributionCenterInventoryHistory,
    distributionCenterInventoryHistoryRef
} from '@api/DistributionCenterInventoryHistory/DistributionCenterInventoryHistory';

export default {
    async saveInventoryHistory(
        inventoryHistory: DistributionCenterInventoryHistory
    ): Promise<DistributionCenterInventoryHistory> {
        const data = await addDoc(distributionCenterInventoryHistoryRef, inventoryHistory);
        inventoryHistory.id = data.id;
        await updateDoc(doc(distributionCenterInventoryHistoryRef, inventoryHistory.id), { ...inventoryHistory });
        return inventoryHistory;
    },
    async getInventoryHistories(distributionCenterId: string): Promise<DistributionCenterInventoryHistory[]> {
        const inventoryHistories: DistributionCenterInventoryHistory[] = [];
        const queryDoc = query(
            distributionCenterInventoryHistoryRef,
            where('distributionCenterId', '==', distributionCenterId),
            orderBy('date', 'desc')
        );
        const snapshot = await getDocs(queryDoc);
        if (!snapshot.empty) {
            snapshot.docs.map((doc: any) => {
                const data = doc.data() as DistributionCenterInventoryHistory;
                data.id = doc.id;
                inventoryHistories.push(data);
            });
        }
        return inventoryHistories;
    },
    async getInventoryHistory(inventoryHistoryId: string): Promise<DistributionCenterInventoryHistory> {
        const documentData = await getDoc(doc(distributionCenterInventoryHistoryRef, inventoryHistoryId));
        return documentData.data() as DistributionCenterInventoryHistory;
    },
    async deleteInventoryHistory(inventoryHistoryId: string): Promise<void> {
        await deleteDoc(doc(distributionCenterInventoryHistoryRef, inventoryHistoryId));
        return;
    }
};
